import _ from 'lodash';
import { setRecoil } from 'recoil-nexus';

import mainStore from 'src/stores/main';
import { IClientConfig } from 'src/client-config/config';
import {NotifyTypeEnum} from "src/constants/enums/notifyTypes";
import { ICurrencyConfig, IDefer } from 'src/constants/interfaces';
import { roundAmount } from 'src/rules/calculation/helpers';
import {storeAddNotifyMessage, storeRemoveNotifyMessage} from "src/stores/notifyMessages";

const displayViewMessage = (type: NotifyTypeEnum, text: string | string[], description: string | string[]) => {
    const messageId = storeAddNotifyMessage(type, text, description);

    return _.partial(storeRemoveNotifyMessage, messageId);
};

export const viewMessage = {
    info: _.partial(displayViewMessage, NotifyTypeEnum.Info),
    error: _.partial(displayViewMessage, NotifyTypeEnum.Error),
    warning: _.partial(displayViewMessage, NotifyTypeEnum.Warning),
    success: _.partial(displayViewMessage, NotifyTypeEnum.Success),
};

export const openDeferPopup = async <ResolveValue>(key: string) => {
    const defer: IDefer<ResolveValue> = { resolve: () => {} };
    const promise = new Promise<ResolveValue>((resolve) => defer.resolve = resolve);

    setRecoil(mainStore, mainState => ({ ...mainState, openPopup: { key, props: { defer }} }));

    const result = await promise;

    setRecoil(mainStore, mainState => ({ ...mainState, openPopup: undefined }));

    return result;
};

export const getAmountWithCurrency = (amount: number, config: IClientConfig, currencyConfig?: ICurrencyConfig) => {
    const roundedAmount = roundAmount(amount, currencyConfig);
    const currencyName = currencyConfig?.name || ''

    if (config.useCurrencySymbol) return `${config.currencySymbol[currencyName || '']} ${roundedAmount}`;

    return `${roundedAmount} ${currencyName}`;
};

export const getIsScrolledToBottom = (element: HTMLElement, tolerance = 50) => {
  const scrollHeight = element.scrollHeight;
  const clientHeight = element.clientHeight;
  const scrollTop = element.scrollTop;

  return scrollTop + clientHeight >= scrollHeight - tolerance;
};